
import  { DbaRegistriesBasicInfoComponent } from './shipx-registries-basic-info.component';
import  { DbaRegistriesGSTInfoComponent } from './shipx-registries-gst-info.component';
import  { DbaRegistriesPanInfoComponent } from './shipx-registries-pan-info.component';
import  { DbaRegistriesKeypairInfoComponent } from './shipx-registries-keypair-info.component';
import TabContainer from '../../../../../common/components/tab/containers/tab.containers';

function DbaRegistriesComponent ({ 
  id, handleBacicInnerFormChange, handleInnerFormChange, dbnpname, opsnumber, subDomains, domains, countries, back, handleFormSubmit, selectedDbaRegistry 
}: any) {
    const tabItems=[
        {
            id:1,
            title:'DBA Registry',
            component: <DbaRegistriesBasicInfoComponent 
            handleBacicInnerFormChange={handleBacicInnerFormChange}
            selectedDbaRegistry={selectedDbaRegistry}
            dbnpname={dbnpname}
            opsnumber={opsnumber}
            subDomains={subDomains}
            domains={domains}
            countries={countries}
        />,
        isVisible:true,
        },
        {
            id:2,
            title:'GST',
            component: <DbaRegistriesGSTInfoComponent 
            handleInnerFormChange={handleInnerFormChange}
            selectedDbaRegistry={selectedDbaRegistry}
           />,
            isVisible:true,
        },
        {
            id:3,
            title:'PAN',
            component: <DbaRegistriesPanInfoComponent
            handleInnerFormChange={handleInnerFormChange}
            selectedDbaRegistry={selectedDbaRegistry}
        />,
        isVisible:true,
        },
        {
            id:4,
            title:'KeyPair',
            component: <DbaRegistriesKeypairInfoComponent 
            handleBacicInnerFormChange={handleBacicInnerFormChange}
            selectedDbaRegistry={selectedDbaRegistry}
           />,
           isVisible:id > 0 ? true : false,
        }
     
      
      ]
  return (
    <div className="flex flex-col items-center w-full px-5 overflow-auto h-screen">
       
     
    <TabContainer tabItems={tabItems} />
 
   
     </div>
  );
}
export default DbaRegistriesComponent;
